// Arabic strings for the redesigned Sales analytics workspace
// (components/Reports/SalesWorkspace). Kept separate from the legacy
// Reports/Sales module so the old report wording is untouched.
const trans = {
  // Page chrome
  "Sales analytics across orders, line items, payments and geography.":
    "تحليلات المبيعات عبر الطلبات والعناصر والمدفوعات والموقع الجغرافي.",
  "Drill-down": "تفاصيل",
  Excel: "إكسل",
  "Preparing export...": "جارٍ تجهيز التصدير...",
  "Loading more…": "جارٍ تحميل المزيد…",

  // Tab labels
  "Line Items": "عناصر الطلب",
  "Payment Methods": "طرق الدفع",
  "Geography / Map": "الموقع الجغرافي / الخريطة",

  // Filters
  "Date basis": "أساس التاريخ",
  "Transaction date": "تاريخ المعاملة",
  "Order received date": "تاريخ استلام الطلب",
  "Expected delivery date": "تاريخ التسليم المتوقع",

  // Overview KPIs / hints (Sales workspace overview)
  AOV: "متوسط الطلب",
  Taxes: "الضرائب",
  "Additional charges": "رسوم إضافية",
  "Tax collected on orders": "الضريبة المُحصّلة على الطلبات",
  "Delivery and service fees on orders": "رسوم التوصيل والخدمة على الطلبات",

  // Leakage panel
  "Where the money goes": "أين تذهب الأموال",
  "Gross sales less discounts and refunds":
    "إجمالي المبيعات ناقص الخصومات والمبالغ المستردة",
  refunded: "مستردة",

  // Branch scorecard
  "Branch scorecard": "بطاقة أداء الفروع",
  "Click a branch to filter the whole page": "اضغط على فرع لتصفية الصفحة بالكامل",
  "Avg. order": "متوسط الطلب",
  "Refund %": "نسبة الاسترداد",
  "Sales share": "الحصة", // unique key — global "Share" is mistranslated as "نشر"

  // Heatmap
  "Busiest times": "أوقات الذروة",
  "Orders by day of week and hour": "الطلبات حسب يوم الأسبوع والساعة",
  "Sales heatmap": "خريطة حرارية للمبيعات",
  "Order intensity by delivery area": "كثافة الطلبات حسب منطقة التوصيل",

  // Trend
  "Sales over time": "المبيعات عبر الزمن",
  "Net sales by selected date basis": "صافي المبيعات حسب التاريخ المحدد",

  // Mix / ranked panels
  "Sales by payment method": "المبيعات حسب طريقة الدفع",
  "Payment method by channel": "طريقة الدفع حسب القناة",
  "Payment method by branch": "طريقة الدفع حسب الفرع",
  "Orders by area": "الطلبات حسب المنطقة",
  "Revenue by area": "الإيرادات حسب المنطقة",
  "Customers by area": "العملاء حسب المنطقة",
  "AOV by area": "متوسط الطلب حسب المنطقة",
  "Areas served": "المناطق المخدومة",
  "Avg. order value": "متوسط قيمة الطلب",

  // Orders table columns
  "Customer name": "اسم العميل",
  "Customer phone": "هاتف العميل",
  "Order source": "مصدر الطلب",
  "Payment method": "طريقة الدفع",
  "Gross amount": "المبلغ الإجمالي",
  "Refund amount": "قيمة الاسترداد",
  "Net amount": "المبلغ الصافي",

  // Line items
  "Group item-level sales by product, option, or modifier.":
    "تجميع مبيعات العناصر حسب المنتج أو الخيار أو الإضافة.",
  Ungrouped: "غير مُجمّع",
  "By product": "حسب المنتج",
  "By option": "حسب الخيار",
  "By modifier": "حسب الإضافة",
  "Grouped Line Items": "العناصر المُجمّعة",
  Group: "المجموعة",
  "Option/modifier": "الخيار/الإضافة",
  "Unit price": "سعر الوحدة",
  Weight: "الوزن",
  "Total amount": "الإجمالي",

  // Payments
  "Sales split across payment methods, branches and channels.":
    "توزيع المبيعات عبر طرق الدفع والفروع والقنوات.",
  "Total collected": "إجمالي المُحصّل",
  "Top method": "الطريقة الأكثر استخدامًا",
  "Cash share": "حصة النقد",
  "% of total sales": "% من إجمالي المبيعات",

  // Misc fallbacks
  Unknown: "غير معروف",
};

export default trans;
